import React, { useState } from 'react';
import { Platform, Pressable, Text, StyleSheet } from 'react-native';

export function GlossySaveButton({ onPress, disabled, children, theme, style, textStyle }) {
  const [hovered, setHovered] = useState(false);
  const green = theme.brand.accent;
  const greenDark = theme.brand.accentHover || '#219a52';
  const greenLight = '#45d685';
  const inactive = disabled;

  return (
    <Pressable
      onPress={onPress}
      disabled={inactive}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={({ pressed }) => [
        styles.base,
        {
          opacity: inactive ? 0.55 : pressed ? 0.94 : 1,
          transform: [{ scale: hovered && !inactive ? 1.015 : 1 }],
        },
        Platform.OS === 'web'
          ? {
              backgroundImage: inactive
                ? undefined
                : hovered
                  ? `linear-gradient(180deg, ${greenLight} 0%, ${green} 38%, ${greenDark} 100%)`
                  : `linear-gradient(180deg, ${greenLight}cc 0%, ${green} 42%, ${greenDark} 100%)`,
              boxShadow: inactive
                ? 'none'
                : hovered
                  ? `0 8px 22px ${green}55, inset 0 1px 0 rgba(255,255,255,0.42), inset 0 -1px 0 rgba(0,0,0,0.12)`
                  : `0 3px 10px ${green}40, inset 0 1px 0 rgba(255,255,255,0.28), inset 0 -1px 0 rgba(0,0,0,0.08)`,
            }
          : {
              backgroundColor: green,
            },
        style,
      ]}
    >
      <Text style={[styles.text, textStyle]}>{children}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    marginTop: 4,
    minHeight: 42,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
    paddingVertical: 11,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.22)',
  },
  text: {
    color: '#ffffff',
    fontWeight: '800',
    fontSize: 13,
    letterSpacing: 0.2,
  },
});

export default GlossySaveButton;
